if($('.project-detail-page').length) {
    $('header').addClass('projects-header');
    if($('.projects-menu > ul > li > .sub-menu').length) {
        $('header').addClass('submenu-active');
    }

    $('.project-detail-link').click(function () {
       $('.project-detail-box').slideDown();
    });

    $('.close-detail-box').click(function () {
        $('.project-detail-box').slideUp();
    });

    $('.project-detail-page').imagesLoaded(function () {
        $('.gallery-wrapper').masonry({
            itemSelector: '.gallery-item'
        });
    });

    var clickedImage;

    $('.gallery-grid .vc_single_image-wrapper').click(function(){
        clickedImage = $(this).find('img').attr('src');
    });



    $('.gallery-grid').click(function () {
        var images = $(this).find('img').map(function(){
            return $(this).attr('src')
        }).get();

        var index = images.indexOf(clickedImage);

        $('.project-detail-page').append('<div class="full-page-slider"></div>');

        for (i=0; i < images.length; i++) {
            $('.full-page-slider').append('<div><img src="'+images[i]+'" alt=""></div>');
        }
        $('.full-page-slider').slick({
            autoplay: false,
            draggable: true,
            fade: false,
            speed: 1000,
            arrows: true,
            dots: true,
            initialSlide: index,
            prevArrow: '<a href="javascript:;" class="arrow prev"></a>',
            nextArrow: '<a href="javascript:;" class="arrow next"></a>'
        });
        $('.full-page-slider').append('<span class="close"></span>');
        $('.full-page-slider').addClass('active');

        $('.full-page-slider .close').on('click',function () {
            $('.full-page-slider').removeClass('active');
            setTimeout(function () {
                $('.full-page-slider').remove();
            }, 500);
        });
    });

    $(function () {
       var containerWidth = $('.featured-image').width();
       $('.project-detail-box').css('width', containerWidth-120+'px');
       console.log(containerWidth);
    });
}